import { defineMessages } from 'react-intl'

const messages = defineMessages({
  accessoriesTitle: {
    defaultMessage: 'Car Accessories | Vehicle Add-ons | Automotive Extras'
  },
  accessoriesDescription: {
    defaultMessage:
      'Buy and sell car accessories, vehicle add-ons and automotive extras online. Fast delivery & click & collect available on all automotive accessories for your vehicle.'
  },
  brakesTitle: {
    defaultMessage: 'Car Brakes | Brake Discs | Calipers | Pads | Brake Kits'
  },
  brakesDescription: {
    defaultMessage:
      'Buy and sell car brakes, brake discs, calipers, pads and complete brake kits online. Fast delivery & click & collect available on all braking system components.'
  },
  carBodyExternalTitle: {
    defaultMessage: 'External Body Panels | Bumpers | Wings | Bonnets | Grilles'
  },
  carBodyExternalDescription: {
    defaultMessage:
      'Buy and sell external body panels, bumpers, wings, bonnets and grilles online. Fast delivery & click & collect available on all exterior body components.'
  },
  carBodyInternalTitle: {
    defaultMessage: 'Car Interior Parts | Seats | Dashboard | Door Cards | Trim'
  },
  carBodyInternalDescription: {
    defaultMessage:
      'Buy and sell car interior parts, seats, dashboard components, door cards and trim online. Fast delivery & click & collect available on all cabin accessories.'
  },
  climateControlTitle: {
    defaultMessage: 'Climate Control | Heater | AC | Ventilation | HVAC Parts'
  },
  climateControlDescription: {
    defaultMessage:
      'Buy and sell climate control systems, heaters, AC components, ventilation and HVAC parts online. Fast delivery & click & collect available on all temperature control items.'
  },
  coolingSystemTitle: {
    defaultMessage:
      'Engine Cooling | Radiators | Water Pumps | Fans | Thermostats'
  },
  coolingSystemDescription: {
    defaultMessage:
      'Buy and sell engine cooling components, radiators, water pumps, fans and thermostats online. Fast delivery & click & collect available on all cooling system parts.'
  },
  drivelineTitle: {
    defaultMessage:
      'Driveline | Driveshafts | CV Joints | Propshafts | Differentials'
  },
  drivelineDescription: {
    defaultMessage:
      'Buy and sell driveline components, driveshafts, CV joints, propshafts and differentials online. Fast delivery & click & collect available on all transmission parts.'
  },
  electricalTitle: {
    defaultMessage:
      'Automotive Electrical | Switches | Modules | Sensors | Wiring'
  },
  electricalDescription: {
    defaultMessage:
      'Buy and sell automotive electrical items, switches, modules, sensors and wiring online. Fast delivery & click & collect available on all vehicle electrical components.'
  },
  engineTitle: {
    defaultMessage:
      'Engine Parts | Pistons | Gaskets | Bearings | Valves | Blocks'
  },
  engineDescription: {
    defaultMessage:
      'Buy and sell engine parts, pistons, gaskets, bearings, valves and engine blocks online. Fast delivery & click & collect available on all motor components.'
  },
  exhaustTitle: {
    defaultMessage:
      'Exhaust Systems | Manifolds | Catalysts | Silencers | Pipes'
  },
  exhaustDescription: {
    defaultMessage:
      'Buy and sell exhaust systems, manifolds, catalysts, silencers and exhaust pipes online. Fast delivery & click & collect available on all exhaust components.'
  },
  fuelAndInductionTitle: {
    defaultMessage:
      'Fuel System | Injectors | Fuel Pumps | Air Intake | Carburettors'
  },
  fuelAndInductionDescription: {
    defaultMessage:
      'Buy and sell fuel system components, injectors, fuel pumps, air intake and carburettors online. Fast delivery & click & collect available on all fuel and induction parts.'
  },
  gearboxTitle: {
    defaultMessage:
      'Gearbox | Transmission | Clutch | Gears | Selectors | Synchro'
  },
  gearboxDescription: {
    defaultMessage:
      'Buy and sell gearbox components, transmissions, clutches, gears, selectors and synchro parts online. Fast delivery & click & collect available on all transmission items.'
  },
  servicePartsTitle: {
    defaultMessage:
      'Service Parts | Filters | Spark Plugs | Oils | Belts | Fluids'
  },
  servicePartsDescription: {
    defaultMessage:
      'Buy and sell service parts, filters, spark plugs, oils, belts and fluids online. Fast delivery & click & collect available on all service parts.'
  },
  steeringTitle: {
    defaultMessage: 'Steering Parts | Racks | Boxes | Power Steering | Linkages'
  },
  steeringDescription: {
    defaultMessage:
      'Buy and sell steering parts, racks, steering boxes, power steering and linkages online. Fast delivery & click & collect available on all steering components.'
  },
  suspensionTitle: {
    defaultMessage:
      'Suspension Parts | Springs | Shock Absorbers, Struts | Control Arms | Ball Joints | Bushings | Sway Bars'
  },
  suspensionDescription: {
    defaultMessage:
      'Buy and sell suspension components including coil springs, leaf springs, bushings, sway bars & torsion bars. Specialist parts that absorb shocks, reduce vibration & improve handling. '
  },
  toolsTitle: {
    defaultMessage:
      'Professional Automotive Tools | Garage Tools | Auto Workshop Equipment'
  },
  toolsDescription: {
    defaultMessage:
      'Buy and sell specialist automotive tools for restoration, performance upgrades & vehicle maintenance. Quality hand tools, diagnostic kits & garage essentials.'
  },
  tyresTitle: {
    defaultMessage:
      'Car Tyres Online | New & Used Tyres | Summer | Winter | All-Season | Performance'
  },
  tyresDescription: {
    defaultMessage:
      'Buy and sell car tyres online. New and used tyres in various profiles, sizes, speed ratings, load indices & tread patterns. Fast delivery & click & collect available on all tyres.'
  },
  wheelsTitle: {
    defaultMessage:
      'Wheels | Alloys | Steel Rims | Hubs | Bearings | Complete Wheel Assemblies'
  },
  wheelsDescription: {
    defaultMessage:
      'Buy and sell wheels online including alloys, steel rims, wheel hubs, centre caps, bearings, bolt patterns, offset designs & custom fitments. Fast delivery & click & collect available on all wheel components.'
  },
  windowsAndGlassTitle: {
    defaultMessage:
      'Automotive Glass | Windscreens | Side Windows | Rear Glass | Quarter Lights | Seals'
  },
  windowsAndGlassDescription: {
    defaultMessage:
      'Buy and sell automotive glass including windscreens, door windows, rear screens, window mechanisms, sunroofs and glass repair kits. Fast delivery & click & collect available on windows and glass.'
  },
  defaultTitle: {
    defaultMessage:
      'Car Parts Marketplace | Buy & Sell Auto Parts Online | Auto Parts Online Store | ifndautoparts'
  },
  defaultDescription: {
    defaultMessage:
      'Buy and sell auto parts online through our car parts marketplace. Find new and used components from verified sellers on our trusted auto parts online store. List and sell your car parts with ease. Delivery or click & collect available on all automotive parts.'
  }
})

export const metaData = {
  accessories: {
    title: messages.accessoriesTitle,
    description: messages.accessoriesDescription
  },
  brakes: {
    title: messages.brakesTitle,
    description: messages.brakesDescription
  },
  'car-body-external': {
    title: messages.carBodyExternalTitle,
    description: messages.carBodyExternalDescription
  },
  'car-body-internal': {
    title: messages.carBodyInternalTitle,
    description: messages.carBodyInternalDescription
  },
  'climate-control': {
    title: messages.climateControlTitle,
    description: messages.climateControlDescription
  },
  'cooling-system': {
    title: messages.coolingSystemTitle,
    description: messages.coolingSystemDescription
  },
  driveline: {
    title: messages.drivelineTitle,
    description: messages.drivelineDescription
  },
  electrical: {
    title: messages.electricalTitle,
    description: messages.electricalDescription
  },
  engine: {
    title: messages.engineTitle,
    description: messages.engineDescription
  },
  exhaust: {
    title: messages.exhaustTitle,
    description: messages.exhaustDescription
  },
  'fuel-and-induction': {
    title: messages.fuelAndInductionTitle,
    description: messages.fuelAndInductionDescription
  },
  gearbox: {
    title: messages.gearboxTitle,
    description: messages.gearboxDescription
  },
  'service-parts': {
    title: messages.servicePartsTitle,
    description: messages.servicePartsDescription
  },
  steering: {
    title: messages.steeringTitle,
    description: messages.steeringDescription
  },
  suspension: {
    title: messages.suspensionTitle,
    description: messages.suspensionDescription
  },
  tools: {
    title: messages.toolsTitle,
    description: messages.toolsDescription
  },
  tyres: {
    title: messages.tyresTitle,
    description: messages.tyresDescription
  },
  wheels: {
    title: messages.wheelsTitle,
    description: messages.wheelsDescription
  },
  'windows-and-glass': {
    title: messages.windowsAndGlassTitle,
    description: messages.windowsAndGlassDescription
  },
  default: {
    title: messages.defaultTitle,
    description: messages.defaultDescription
  }
}
